/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".navbar-brand[_ngcontent-%COMP%]{font-weight:900;color:#fff}.navbar[_ngcontent-%COMP%]{min-height:60px}.navbar-nav[_ngcontent-%COMP%]   .nav-item[_ngcontent-%COMP%]   .nav-link[_ngcontent-%COMP%]{font-weight:600;font-size:16px;color:#fff}.navbar[_ngcontent-%COMP%]   .nav-item[_ngcontent-%COMP%]   .active[_ngcontent-%COMP%], .navbar[_ngcontent-%COMP%]   .nav-link[_ngcontent-%COMP%]:hover, .navbar[_ngcontent-%COMP%]   .navbar-brand[_ngcontent-%COMP%]:hover{color:#ffb300!important}"];
export { styles as styles };
